
import React, { useMemo } from 'react'
import ContentForm from './_form'

export default function WorkoutDailyfixAdd (props) {
  const data = useMemo(() => ({ weight: 100, textColor: 'FFFFFF' }), [])
  return (
    <ContentForm originalContent={data} {...props} />
  )
}